import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, FormGroup,Button } from 'react-bootstrap'
import { warning,green } from '../../../../utils/sitecolors'
import { sendInvalidInfoNotification } from './api'


class CorrectEventInfo extends Component {

	constructor(props){
		super(props)
		this.state = {
			commentEntered: false,
			infoIsIncorrect:false,
			comment:'',
			sendingNotification:false,
			notificationSent:false
		}
		this.handleInvalidInfo = this.handleInvalidInfo.bind(this)
		this.handleSaveInvalidInfo = this.handleSaveInvalidInfo.bind(this)
		this.handleCommentChange = this.handleCommentChange.bind(this)
	}
	componentDidMount()
	{
	}
	handleInvalidInfo (event) 
	{
		//const { value } = event.target
		console.log('handleInvalid info value', typeof(event.target.value))
		if ( event.target.value == 'false')
		{
			console.log('handleInvalid setting state to infoIsIncorrect:true', event.target.value)
			this.setState({ 
				infoIsIncorrect:true
			})
		}
		else
		{
			this.setState({ 
				infoIsIncorrect:false
			})
			this.props.onInfoIsCorrect(true)
		}
	}
	handleSaveInvalidInfo()
	{
		const { comment }        = this.state
		const { eventId, token } = this.props
		const _this  = this

    _this.setState({ sendingNotification:true,notificationSent:false })
		sendInvalidInfoNotification(eventId,comment,token).then(function(resp)
		{
			console.log('sendInvalidInfoNotification response',resp)
			_this.setState({ sendingNotification:false,notificationSent:true })
		})
	}
	handleCommentChange(event)
	{
		const comment = event.target.value
		const commentEntered = comment.length > 0
		this.setState({ commentEntered,comment })
	}
	render() {

		const { 
			infoIsIncorrect,
			sendingNotification,
			notificationSent 
		} = this.state

		return (
				<Col sm={12} md={12} lg={12}>
					<FormGroup>
					{ !notificationSent &&
						(<Col sm={6 } md={6} lg={5} style={{ padding:'0' }}>
							<label  style={{ fontSize: '16px',color:warning, margin:'0 5px 0 0', padding:'0' }}>Is the information above correct?{' '}</label>
							<label  className="radio-inline c-radio" style={{ color:warning , padding:'0 0 0 2px' }} htmlFor="validyes">
								<input id="validyes" type="radio" name="validinfo"  style={{ margin:'0',padding:'0' }} value onChange={this.handleInvalidInfo}  />
								<em className="fa fa-circle"   style={{ margin:'0',padding:'0' }}/>&nbsp;&nbsp;Yes
							</label>
							<label className="radio-inline c-radio" style={{ color:warning, padding:'0',margin:'0' }} htmlFor="validno"  >
								<input id="validno" type="radio"  name="validinfo" style={{ padding:'0',margin:'0' }}  value={false} onChange={this.handleInvalidInfo} checked={this.state.infoIsIncorrect === true} />
								<em className="fa fa-circle" style={{ margin:'0',padding:'0' }}  />&nbsp;&nbsp;No 
							</label> 
						</Col>)
					}
					{ 
							infoIsIncorrect && !notificationSent &&
							( 
								<Col sm={6} md={6} lg={7} style={{ margin:'0 0 0 -11%',padding:'0' }}>
									<Col sm={8 } md={6} lg={11}>
										<input className="form-control" style={{ borderRadius:'0' }} type='text' onChange={this.handleCommentChange} placeholder='Type your comments' autoFocus/>
									</Col>
									<Col sm={4 } md={6} lg={1}> 
										<Button onClick={this.handleSaveInvalidInfo}  style={{ marginLeft:'-31px',fontSize:'16px',  height:'35.2px', borderRadius:'0',color:green,fontWeight:'bold' }} disabled={ !this.state.commentEntered }>
										<i className={sendingNotification ? "fa fa-spinner fa-spin":"fa fa-envelope-o"} aria-hidden="true" />&nbsp;&nbsp;&nbsp;Send</Button>
									</Col>
								</Col>
							) 
						}
						{ 
						notificationSent && 
							( 
								<Col sm={6} md={6} lg={7} style={{ margin:'0',padding:'0' }}>
									<label style={{ color:warning,fontSize:'16px' }}>	<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;Thank you for your feedback. USBC will contact you once the information has been corrected.</label>
								</Col>
							) 
						}
					</FormGroup>
				</Col>
			)
	}   
}
CorrectEventInfo.propTypes = {
	onInfoIsCorrect: PropTypes.func,
	eventId: PropTypes.number,
	token:PropTypes.string
}
export default CorrectEventInfo


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/CorrectEventInfo/index.js